import styled from '@emotion/styled';

export const IconBox = styled.div<{ size?: string }>`
  display: flex;
  width: ${({ size }) => (!size ? '16px' : size)};
  height: ${({ size }) => (!size ? '16px' : size)};
  align-items: center;
  justify-content: center;
`;

export const LabelText = styled.span`
  /* color: ${({ theme }) => theme.colors.neutral[700]}; */
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
`;
